import { createSlice } from '@reduxjs/toolkit';
import { buildAsyncReducers } from '../thunkTemplate';
import { management as initialState } from '../initialState';

import {
  authenticateManagementUser,
  getManagementOrganizations,
  getManagementUsers,
  createManagementOrg,
  getManagementStats,
} from './_management';

const { reducer } = createSlice({
  name: 'management',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    buildAsyncReducers(builder, [
      authenticateManagementUser,
      getManagementOrganizations,
      getManagementUsers,
      createManagementOrg,
      getManagementStats,
    ]);
  },
});

export {
  authenticateManagementUser,
  getManagementOrganizations,
  getManagementUsers,
  createManagementOrg,
  getManagementStats,
};
export default reducer;
